import { useEffect, useState } from "react";
import styles from "./flag_filter_modal.module.css";

import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import { Dialog, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { post } from "util/requests";
import { corelab_api_url } from "config";
import { Checkbox } from "@mui/material";
import { current } from "@reduxjs/toolkit";

export default function FlagFilterModal(props) {
  const { isOpen, close, onYes, data, allFilesList, selectedFile, handleModifyFlags, filters, setFilters, clear } =
    props;
  const [value, setValue] = useState((data && data.length && data[0].name) || "");
  const [loading, setLoading] = useState(false);

  const [currentFlags, setCurrentFlags] = useState({});

  useEffect(() => {
    data && data.length && setValue(data && data.length && data[0].name);
  }, [data, isOpen]);

  const is_file = true; //data[0]?.type === "file";
  let extension = (is_file && value.split(".").slice(-1)[0]) || "";

  useEffect(() => {
    setCurrentFlags(filters || {});
  }, [filters]);

  const switch_flag_state = (flag) => {
    let _tmp = [];
    if (!currentFlags._true?.includes(flag) && !currentFlags._false?.includes(flag)) {
      _tmp = [...(currentFlags._true || [])];
      _tmp.push(flag);
      setCurrentFlags({ ...currentFlags, _true: _tmp });
    } else if (currentFlags._true?.includes(flag)) {
      _tmp = [...(currentFlags._false || [])];
      _tmp.push(flag);
      setCurrentFlags({ _false: _tmp, _true: currentFlags._true?.filter((f) => f !== flag) || [] });
    } else if (currentFlags._false?.includes(flag)) {
      _tmp = [...(currentFlags._true || [])];
      _tmp.push(flag);
      setCurrentFlags({ _true: _tmp, _false: currentFlags._false?.filter((f) => f !== flag) || [] });
    }
  };
  const get_flag_node = (flag) => {
    if (currentFlags._false?.includes(flag)) {
      return (
        <div className={styles.red_text} onClick={() => switch_flag_state(flag)}>
          {`not ${flag}`.toUpperCase()}
        </div>
      );
      // return `not ${flag}`.toUpperCase();
    } else {
      return <div onClick={() => switch_flag_state(flag)}>{`${flag}`.toUpperCase()}</div>;
    }
  };

  return (
    <Dialog open={isOpen} onClose={close}>
      <div className={styles.wrapper}>
        <div className={styles.modal_wrapper}>
          <div className={styles.modal_title}>{`Filter by Flag`}</div>
          <div className={styles.description}>(click on flag name after selected to switch state)</div>
          <div className={styles.modal_body}>
            <div>
              {["downloaded", "imaging_qc", "deidentified", "read", "segmented"].map((flag) => (
                <div className={styles.flag_wrapper}>
                  <div
                    onClick={() => {
                      let _tmp;
                      if (currentFlags._true?.includes(flag) || currentFlags._false?.includes(flag)) {
                        setCurrentFlags({
                          _true: currentFlags._true?.filter((f) => f !== flag) || [],
                          _false: currentFlags._false?.filter((f) => f !== flag) || [],
                        });
                      } else {
                        _tmp = [...(currentFlags._true || [])];
                        _tmp.push(flag);
                        setCurrentFlags({ ...currentFlags, _true: _tmp });
                      }
                    }}
                  >
                    <Checkbox
                      checked={currentFlags._true?.includes(flag) || currentFlags._false?.includes(flag) || false}
                    />
                  </div>
                  {get_flag_node(flag)}
                </div>
              ))}
            </div>
          </div>

          <div className={styles.modal_button_wrapper}>
            <LoadingButton
              disabled={false}
              variant="contained"
              loading={loading}
              onClick={() => {
                if (currentFlags?._true?.length === 0 && currentFlags?._false?.length === 0) {
                  setFilters(null);
                } else {
                  setFilters(currentFlags);
                }
              }}
            >
              Filter
            </LoadingButton>
            <LoadingButton
              disabled={false}
              variant="outlined"
              loading={false}
              onClick={() => {
                clear();
                setCurrentFlags({});
              }}
            >
              Clear All
            </LoadingButton>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
